import { Kyp, KypDateField, KypSortOption } from 'data/models/Kyp';
import { RootState } from 'data/store';

export const selectKyps = (state: RootState): Kyp[] => {
  return state.KYP.kyps;
};

export const selectKypIsLoading = (state: RootState): boolean => {
  return state.KYP.isLoading;
};

export const selectSelectedKyp = (state: RootState): Kyp | undefined => {
  return state.KYP.selectedKyp;
};

export const selectKypSortBy = (state: RootState): KypSortOption | undefined => {
  return state.KYP.sortBy;
};

export const selectKypSortingDate = (state: RootState): KypDateField | undefined => {
  return state.KYP.sortingDate;
};
